// The first run's wizard offered at the admin's sign-in (STAGE_7 7.9): on a new
// installation - or one whose wizard is started and not finished - the admin lands in
// the wizard instead of the first section, once per sign-in. Nobody else is asked, and
// the server not answering never stands between the admin and the system.

import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { api } from '@/api/client';
import { FullScreenSpin } from '@/components/FullScreenSpin';
import { useCurrentUser } from '@/features/auth/authContext';

import { SETUP_KEY, markOffered, wasOffered } from './setupApi';

export const SETUP_PATH = '/setup';

export function SetupGate({ children }: { children: ReactNode }) {
  const user = useCurrentUser();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const asking = user.role === 'admin' && !wasOffered(user.id);
  const setup = useQuery({
    queryKey: [SETUP_KEY],
    queryFn: ({ signal }) => api.get('/setup', { signal }),
    enabled: asking,
  });

  useEffect(() => {
    if (!asking || setup.isPending) return;
    markOffered(user.id);
    if (setup.data?.offered && pathname !== SETUP_PATH) void navigate(SETUP_PATH, { replace: true });
  }, [asking, setup.isPending, setup.data, user.id, pathname, navigate]);

  if (asking && setup.isPending) return <FullScreenSpin />;
  return children;
}
